<p-dialog
  [header]="dialogHeader()"
  [visible]="state().visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '520px' }">
  <div class="w-full">
    <p class="text-(--stela-text-secondary)">
      {{ userMessage() }}
    </p>

    <!--
      In production we keep the user-facing dialog clean: the user only sees
      a friendly summary plus the timestamp so they can quote it on a ticket.
      All technical details (status code, route, HTTP method, exception type,
      stack trace, AI payload) are gated behind the "Ver detalles" toggle.
      In dev / non-production builds we render them by default because that's
      where developers expect them.
    -->
    @if (showTechnicalSummary()) {
      @if (state().statusCode) {
        <p class="mb-1"><strong>Código:</strong> {{ state().statusCode }}</p>
      }

      @if (state().url) {
        <p class="mb-1"><strong>Ruta:</strong> {{ state().url }}</p>
      }

      @if (state().method) {
        <p class="mb-1"><strong>Método:</strong> {{ state().method }}</p>
      }

      @if (state().exceptionType) {
        <p class="mb-1"><strong>Tipo de excepción:</strong> {{ state().exceptionType }}</p>
      }
    }

    @if (state().timestamp) {
      <p class="mb-1"><strong>Hora:</strong> {{ state().timestamp }}</p>
    }

    <div class="mt-3">
      <p-button
        [label]="showDetails() ? 'Ocultar detalles' : 'Ver detalles'"
        (onClick)="toggleDetails()"
        severity="secondary"
        size="small">
      </p-button>
    </div>

    @if (showDetails()) {
      <!-- When the user explicitly opens "Ver detalles" we always show
           everything (including the technical summary in production). -->
      @if (!showTechnicalSummary()) {
        @if (state().statusCode) {
          <p class="mb-1 mt-2"><strong>Código:</strong> {{ state().statusCode }}</p>
        }
        @if (state().url) {
          <p class="mb-1"><strong>Ruta:</strong> {{ state().url }}</p>
        }
        @if (state().method) {
          <p class="mb-1"><strong>Método:</strong> {{ state().method }}</p>
        }
        @if (state().exceptionType) {
          <p class="mb-1"><strong>Tipo de excepción:</strong> {{ state().exceptionType }}</p>
        }
      }
      <pre class="mt-3" style="max-height: 260px; overflow: auto; white-space: pre-wrap;">{{ state().stackTrace || 'Sin detalles adicionales.' }}</pre>
      <div class="mt-3">
        <p class="text-(--stela-text-secondary) text-sm">Formato para IA</p>
        <pre class="mt-2" style="max-height: 220px; overflow: auto; white-space: pre-wrap;">{{ aiPayload() }}</pre>
      </div>
    }
  </div>

  <ng-template #footer>
    @if (showDetails()) {
      <p-button label="Copiar detalles (IA)" (onClick)="copyDetails()" severity="secondary"></p-button>
    }
    <p-button label="Cerrar" (onClick)="close()" severity="primary"></p-button>
  </ng-template>
</p-dialog>
